/**
 * Freeze the page behind an overlay.
 *
 * On a phone this is not cosmetic. A sheet or a drawer that lets the shelf keep
 * scrolling under the finger loses the reader's place the moment they scroll the
 * sheet one pixel too far, and on iOS the rubber band drags the whole page away.
 *
 * Two overlays can be open at once (the chapter drawer over the reader, a panel
 * over the shelf), so the lock counts rather than toggles: the last one out puts
 * the scrollbar back, and no one else's cleanup can unlock the page early.
 */

import { useEffect } from "react";

let holders = 0;
let restore = "";

export function useScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    if (holders === 0) {
      restore = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }
    holders += 1;
    return () => {
      holders -= 1;
      if (holders === 0) document.body.style.overflow = restore;
    };
  }, [active]);
}
